export function decrypt(json) {
    // 1. Base64 decode
    const encryptedBytes = Uint8Array.from(atob(json), (c) => c.charCodeAt(0));

    // 2. XOR decrypt (must match Go logic)
    const key = new TextEncoder().encode("dealiem");
    const decryptedBytes = encryptedBytes.map(
        (b, i) => b ^ key[i % key.length]
    );

    // 3. Convert to UTF-8 string
    const decoder = new TextDecoder("utf-8");
    const jsonString = decoder.decode(decryptedBytes);

    return jsonString;
}

export function getKey() {
    return "ZGVhbGllbQ==";
}
